/**
 * Trust & community section with trust signals and CTA
 */

import React from 'react';

import css from './TrustSection.module.css';

const TrustSection = ({ onBrowse }) => {
  
  const trustSignals = [
    {
      icon: '✨',
      title: 'Curated by Merrily',
      description: 'Every kit is hand-selected for design, quality, and condition'
    },
    {
      icon: '🔒',
      title: 'Secure Payments',
      description: 'Your payments and deposits are fully protected'
    },
    {
      icon: '🎁',
      title: 'Full Packages Available',
      description: 'Some hosts offer florals, catering, balloon arches, and more. Book everything in one place.'
    },
    {
      icon: '🛡️',
      title: 'Damage Protection',
      description: 'Refundable deposits plus accidental-damage coverage protect both sides'
    },
    {
      icon: '🚚',
      title: 'Delivery Available',
      description: 'Many hosts offer delivery and setup at your venue'
    }
  ];

  return (
    <section className={css.root} id="about">
      <div className={css.container}>

        <div className={css.content}>

          <div className={css.storySection}>
            <div className={css.storyContent}>
              <h2 className={css.title}>
                A new way to host
              </h2>

              <p className={css.story}>
                Merrily is a curated marketplace of thoughtfully styled party kits with add ons including florals, catering, balloon arches, and more. Skip the Pinterest spirals, the last-minute Amazon orders, and the closet full of decor you'll never use again. We've gathered talented hosts and designers in your city to make hosting effortless.
              </p>

              <div className={css.statsRow}>
                <div className={css.stat}>
                  <div className={css.statValue}>8</div>
                  <div className={css.statLabel}>Occasions</div>
                </div>
                <div className={css.stat}>
                  <div className={css.statValue}>Up to 60%</div>
                  <div className={css.statLabel}>Less than buying new</div>
                </div>
                <div className={css.stat}>
                  <div className={css.statValue}>Santa Barbara</div>
                  <div className={css.statLabel}>Launching first</div>
                </div>
              </div>
            </div>
          </div>

          <div className={css.trustSignals}>
            {trustSignals.map((signal, index) => (
              <div key={index} className={css.trustSignal}>
                <div className={css.signalIcon}>{signal.icon}</div>
                <div className={css.signalContent}>
                  <h3 className={css.signalTitle}>{signal.title}</h3>
                  <p className={css.signalDescription}>{signal.description}</p>
                </div>
              </div>
            ))}
          </div>

        </div>
        
        <div className={css.finalCta}>
          <h3 className={css.ctaTitle}>Ready to make your next party amazing?</h3>
          <button className={css.ctaButton} onClick={onBrowse}>
            Browse Party Kits Near You →
          </button>
        </div>

      </div>
    </section>
  );
};

export default TrustSection;
